<template lang="pug">

    div

        .ui.items
            .item
                a.ui.image(v-bind:href='downloadUrl' target='_blank')
                    img(v-bind:src='thumbnailUrl')
                    .ui.left.corner.label: i.download.icon
                .content
                    .header Auftragsbestätigung wurde hochgeladen
                    .extra
                        .ui.small.basic.label
                            i.calendar.icon
                            | {{ date }}
                        .ui.small.basic.label
                            i.time.icon
                            | {{ time }} Uhr
                    .description
                        table.ui.compact.very.basic.collapsing.table
                            tbody
                                tr
                                    td: strong Auflage
                                    td {{ priceModel.printing }}
                                tr
                                    td: strong Herstellungskosten
                                    td {{ production }}
                                tr
                                    td: strong Versandkosten
                                    td {{ shipping }}
                    .extra

                        .ui.checkbox
                            input(
                                type='checkbox'
                                id="reviewed"
                                v-on:click.prevent="markOrderConfirmationAsReviewed()"
                                v-bind:checked='isReviewed'
                                v-bind:disabled="isReviewed === true"
                            )
                            label(for="reviewed") Auftragsbestätigung überprüft

</template>

<script>
    import * as R from "ramda";
    import {to_currency} from "@/utils/currency";
    import {to_ddmmyyyy, to_hhmm} from "@/utils/date";
    import SliderCheckboxField from '@/components/form/SliderCheckboxField'

    export default {

        components: { SliderCheckboxField },

        computed: {

            date() {
                return to_ddmmyyyy(this.fileModel.createdAt)
            },

            downloadUrl() {
                const fileId = R.prop('id', this.fileModel)
                return `/downloads/${fileId}`
            },

            isReviewed() {
                return R.prop('isReviewed', this.orderConfirmationModel)
            },

            production() {
                return to_currency('€')(this.priceModel.production)
            },

            shipping() {
                return to_currency('€')(this.priceModel.shipping)
            },

            thumbnailUrl() {
                return `${this.downloadUrl}?thumbnail`
            },

            time() {
                return to_hhmm(this.fileModel.createdAt)
            },

        },

        methods: {

            async markOrderConfirmationAsReviewed() {
                if (!await this.$growl.confirm('Auftragsbestätigung wirklich als überprüft markieren? Diese Entscheidung kann nicht rückgängig gemacht werden.')) {
                    return
                }

                // Auftragsbestätigung als überprüft setzen und speichern
                const id = R.prop('id', this.orderConfirmationModel)
                const model = R.assoc('isReviewed', true, this.orderConfirmationModel)
                await this.$store.dispatch('orderConfirmations/update', { id, model })

                // Produkt neu laden
                await this.$store.dispatch('products/loadOne', { id: this.productModel.id, force: true })
            }

        },

        props: {

            fileModel: {
                type: Object,
                default: R.always({})
            },

            orderConfirmationModel: {
                type: Object,
                default: R.always({})
            },

            priceModel: {
                type: Object,
                default: R.always({})
            },

            productModel: {
                type: Object,
                required: true
            }

        },

    }


</script>
